/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

export const quantidade = [
  {
    label: (
      <>
        <p>5</p>
      </>
    ),
    value: '5',
  },
  {
    label: (
      <>
        <p>10</p>
      </>
    ),
    value: '10',
  },
  {
    label: (
      <>
        <p>15</p>
      </>
    ),
    value: '15',
  },
];

export const periodo = [
  {
    label: (
      <>
        <p>15</p>
      </>
    ),
    value: '15',
  },
  {
    label: (
      <>
        <p>30</p>
      </>
    ),
    value: '30',
  },
  {
    label: (
      <>
        <p>60</p>
      </>
    ),
    value: '60',
  },
  {
    label: (
      <>
        <p>90</p>
      </>
    ),
    value: '90',
  },
];
